import React, { useState } from 'react'
import useData from '../hooks/useData'
import Loading from './Loading'
import { Link } from 'react-router-dom'
import PageListTitle from './PageListTitle'
import PageListDate from './PageListDate'
import QueryBadge from './QueryBadge'
import URL from './URL'
import URI from 'urijs'
import { isValid, parseISO, format, isAfter, subDays, formatDistanceToNow } from 'date-fns'
const today = new Date()
const nbDays = 90
// console.log({ subDays })
console.log(subDays(today, 7), isAfter(today, subDays(today, 7)))

const byImpressions = (a, b) => (a.impressions < b.impressions && 1) || (a.impressions === b.impressions && '0') || -1

const getPermalinkFromSCURL = (url) => {
    const permalink = URI(url).pathname().substring(1)
    return (permalink.length && permalink) || 'homepage'
}

const Dashboard = () => {
    const newCompetitorPages = useData('competitor_page?scope=dashboard')
    const updateArticles = useData('article?scope=old_published')
    const [date] = useState([subDays(new Date(), nbDays), new Date()])
    const siteArray = useData('site')

    const articleList = useData('article?scope=dropdown')
    const article_list = articleList.data || []
    console.log({ article_list })
    const getArticleIdFromSCURL = (url) => {
        url = url.replace('?amp', '')
        const perm = getPermalinkFromSCURL(url)
        const site_url = URI(url).hostname()
        return ((article_list || []).find((article) => site_url === article.site_url && (article.permalink === perm || article.old_permalink === perm)) || {})
            .id
    }

    const SCData = useData(
        {
            url:
                siteArray.isReady &&
                'google/search_console?dimensions[0]=page&dimensions[1]=query&' +
                    siteArray.data
                        .filter((s) => !!s.ga && !!s.published)
                        .map((s, index) => 'site_id[' + index + ']=' + s.id)
                        .join('&') +
                    '&start_date=' +
                    format(date[0], 'yyyy-MM-dd') +
                    '&end_date=' +
                    format(date[1], 'yyyy-MM-dd'),
            transform: (r) => r && r.filter((i) => Number(i.clicks) === 0 && i.impressions > 100).sort(byImpressions),
        },
        [siteArray.isReady]
    )
    console.log({ SCData })
    return (
        <>
            <div className="row">
                <div className="col-xxl-6 pb-4">
                    {(newCompetitorPages.isReady && (
                        <>
                            <h2>Latest competitor updates</h2>
                            <p>This table displays the lastest 10 articles found on competitors' websites, created or modified.</p>
                            <table className="table mb-5">
                                <tbody>
                                    {newCompetitorPages.data.map((p) => (
                                        <tr key={`${p.id}`}>
                                            <td>
                                                <PageListTitle {...p} />
                                            </td>
                                            <td>
                                                <PageListDate {...p} />
                                            </td>
                                            <td className="text-right">
                                                <Link to={`/competitor/view/${p.competitor_id}?url=${p.url}`} className="btn btn-primary btn-xs ml-1">
                                                    Inspect&nbsp;page
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )) || <Loading text="Loading competitor data" />}
                    {(updateArticles.isReady && (
                        <>
                            <h2>Oldest published articles</h2>
                            <table className="table table-sm">
                                <tbody>
                                    {updateArticles.data.map((article, index) => (
                                        <tr key={`${index}`}>
                                            <td>
                                                {article.site_label}:{' '}
                                                <Link to={`/article/edit/${article.id}`}>
                                                    <PageListTitle {...article} />
                                                </Link>
                                                <small>
                                                    <URL url={'/' + article.permalink} />
                                                </small>
                                            </td>
                                            <td className="text-right">
                                                {isValid(parseISO(article.updated_at)) && formatDistanceToNow(parseISO(article.updated_at))} ago
                                                <br />
                                                <small className="text-muted">{article.updated_at}</small>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )) || <Loading text="Loading oldest published articles" />}
                </div>
                <div className="col-xxl-6 pb-4">
                    {(SCData.isReady && (
                        <>
                            <h2>Article ideas</h2>
                            <p>These keywords triggered a display on Google, but no click. The figures displayed below are for a {nbDays} days period.</p>
                            <table className="table table-sm">
                                <tbody>
                                    {SCData.data.map((i, index) => (
                                        <tr key={`${index}`}>
                                            <td>
                                                <QueryBadge>{i.keys[1]}</QueryBadge>
                                            </td>
                                            <td>
                                                <div>
                                                    <strong>{(article_list.find((a) => a.id === getArticleIdFromSCURL(i.keys[0])) || {}).title}</strong>
                                                </div>
                                                <small>
                                                    <URL>{i.keys[0]}</URL>
                                                </small>
                                            </td>
                                            <td className="text-right">{i.impressions}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )) || <Loading text="Fetching data from Google Search Console API" />}
                </div>
            </div>
        </>
    )
}

export default Dashboard
